<template>
  <!-- D: 서브 전용 상품 컴포넌트 -->
  <div class="product-item-pc">
    <div class="product-info-pc" style="display: flex; width: 100%">
      <div class="product-image">
        <div class="product-img">
          <img
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
            class="no-image"
            @click="() => emits('select', props.product)"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
            @click="() => emits('select', props.product)"
          />
        </div>
      </div>
      <div class="product-info-txt">
        <div class="badge-product-wrap-pr">
          <div v-show="!productBadgeEmptyYn" class="c-product-badge-main">
            <span
              v-show="props.product.setgdYn === 'Y'"
              class="badge type-skyblue"
            >
              SET 제품
            </span>
            <span
              v-if="props.product.zzlqdCls == 'A'"
              class="badge type-purple"
            >
              주제
            </span>
            <span v-if="props.product.zzlqdCls == 'B'" class="badge type-mint">
              경화제
            </span>
            <span v-if="props.product.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span
              v-if="props.product.zzlqdCls == 'D'"
              class="badge type-violet"
            >
              회석제
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'A'"
              class="badge type-olive"
            >
              1액형
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'B'"
              class="badge type-olive"
            >
              2액형
            </span>
            <span
              v-if="props.product.zzlqdtyCls == 'C'"
              class="badge type-olive"
            >
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path"> {{ props.product.prodh1t }} </span>
            <span class="path"> {{ props.product.prodh2t }} </span>
            <span class="path"> {{ props.product.prodh3t }} </span>
          </div>
        </div>
        <div class="product-details-pc">
          <span class="product-code">{{ props.product.matnr }}</span>
          <div class="product-title-pc">{{ props.product.zzmaktx }}</div>
        </div>
        <div class="product-price">
          {{ Utils.currency(props.product.kbetr) }}원
        </div>
      </div>
      <div class="product-main-pr01">
        <div class="action-buttons">
          <div class="c-btn-area-list type-product c-btn-area-list-pc">
            <button
              class="btn-pc-pr btn-outlined"
              @click="() => (data.totalStockListPopEl = true)"
            >
              재고
            </button>
            <button
              type="button"
              class="c-button type-white type-xsmall type-icon c-button-pr"
              data-basket="quickOrder1"
              @click="
                () => pushMyRoom(props.product.matnr, props.product.mtart)
              "
            >
              담기
            </button>
            <button
              type="button"
              class="btn-pc-pr btn-primary btn-pc-pr-btn"
              data-basket="quickOrder1"
              @click="() => emits('buy', { ...props.product, quantity: 1 })"
            >
              바로주문
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="c-toast-black" data-toast="basket1">
    <span class="text">장바구니에 담겼습니다</span>
  </div>
  <div class="c-toast-black is-quick" data-toast="quickOrder1">
    <span class="text">주문서에 담겼습니다주문서에 담겼습니다</span>
  </div>

  <AlertWerks
    :totalStockListPopEl="data.totalStockListPopEl"
    :product="props.product"
    :werks="props.werks"
    @close="() => (data.totalStockListPopEl = false)"
  >
  </AlertWerks>

  <myRoomGroupSelect
    v-if="data.isShowGroupInfoPop"
    :product="props.product"
    @close="() => (data.isShowGroupInfoPop = false)"
  />
</template>
<script setup>
import {
  onMounted,
  defineProps,
  defineEmits,
  computed,
  ref,
  reactive,
} from "vue";
import Utils from "@/js/utils";
import AlertWerks from "@/components/paintpro/common/AlertWerks.vue";
import myRoomGroupSelect from "@/components/paintpro/myRoom/myRoomGroupSelect.vue";
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const data = reactive({
  isShowGroupInfoPop: false,
  totalStockListPopEl: false,
});
const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  werks: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits(["buy", "cart", "select"]);
const imageErrorYn = ref(false);

onMounted(() => {});

const productBadgeEmptyYn = computed(() => {
  return (
    props.product.setgdYn !== "Y" &&
    props.product.zzlqdCls !== "A" &&
    props.product.zzlqdCls !== "B" &&
    props.product.zzlqdCls !== "C" &&
    props.product.zzlqdCls !== "D" &&
    props.product.zzlqdtyCls !== "A" &&
    props.product.zzlqdtyCls !== "B" &&
    props.product.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(props.product.imgFilePath) ||
    Utils.isBlank(props.product.imgFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return (
    FILE_CDN_URL +
    "/" +
    props.product.imgFilePath +
    "/" +
    props.product.imgFileNm
  );
});

// 그룹관리
function pushMyRoom() {
  data.isShowGroupInfoPop = true;
}
</script>
